import React, { createRef, Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  Button,
  Column,
  Dialog,
  DropMenu,
  DropMenuTrigger,
  OverlayTrigger,
  PopOver,
  Portal,
  Select,
  Switch,
  Table,
  Checkbox,
  SelectTree,
} from '@tencent/spaui';
import moment from 'moment';
import { ListView } from '@tencent/ptp-fe-common';
import SpauiColumns from '@tencent/spaui-columns';
import { Tags } from '../../../consts/Tags';
import { RPCFactory } from '../../../utils/RequestUtil';
import Mask from '../../common/Mask';
import LeadsDetailComponent from '../LeadsDetailComponent';
import CallConfirmDialog from '../../common/call/CallConfirmDialog';
import { DateUtil } from '../../../utils/DateUtil';
import { isXunda, judgeIsFromTMC } from '../../../utils';
import { Common } from '../../../consts/Common';
import CustomerType from '../../../consts/CustomerType';
import LeadsOrderType from '../../../consts/LeadsOrderType';

import { getCellsConfig } from '../../../consts/cellConfig';
import { getCellsConfigMap } from '../../../consts/cellConfigMap';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import { leadsScoreTips } from '../../../consts/Tips';
import { isSubAccount } from '../../../consts/multiAccountConfig';
import { LeadsUploadDialog } from '../../common/LeadsUploadDialog';
import useCustomColumn from '../../hooks/useCustomFilter';
import {
  ENABLE_BATCH_TAG_UPDATE,
  showTagEditor,
  leadsCommonFuncAndConfig,
} from './leadsCommonFuncAndConfig';
import { withXundaData } from '../../../cacheAPIData/WithXundaData';
import { isLeadsRole } from '../../../utils/routes';
import { SelectionItemComponent, ValueAreaComponent } from '../qwCustomerList/ownerPicker';
import BatchDistribute from './BatchDistribute';
import { LeadsDedupPart } from '../../common/leadsDedup';
import { PageUtil } from '../../../utils/PageUtil';
import { beaconInstance } from '../../../instrumentation/beaconSetup';

const mapStateToProps = (state) => ({ ...state.leadsManage, industryState: state.global });

const required = ['name', 'tel', 'leadsFollowTagName', 'leadsOpt'];
const unmovableCells = ['name', 'tel', 'leadsFollowTagName', 'leadsOpt'];

let UNIQUE_STATUS = null;

export const StateSelectionComponent = (props) => {
  const { data, onChange, value } = props;
  const handleClick = (val) => {
    onChange(null, val);
  };

  const valueSet = new Set(_.flatten([value]));

  return (
    <ul className="selection-results">
      {
        data.map((item, index) => {
          if (item.isTitle) {
            return (
              <li key={item.data} data-index={index} style={{
                height: 30,
                lineHeight: '30px',
                paddingLeft: 11,
              }}>
                <div className="selection-name">
                  <span className="name" style={{ color: '#296bef' }}>{item.label}</span>
                </div>
              </li>
            );
          }
          return (
            <li key={item.value} className="selection-info" data-index={index} onClick={() => handleClick(item.value)}>
              <div className="selection-addon">
                <Checkbox checked={valueSet.has(item.value)} />
              </div>
              <div className="selection-name" title={item.label}>
                <span className="name">{item.label}</span>
              </div>
            </li>
          );
        })
      }
    </ul>
  );
};

const ReportUniqueTool = {
  getCacheKey() {
    const prefix = '_cache_report_unique_';
    const userId = window.pageProps.operationUserId;
    return prefix + userId;
  },
  getCachedStatus() {
    const cacheKey = this.getCacheKey();
    const cachedValue = localStorage.getItem(cacheKey);
    return cachedValue === 'true';
  },
  setCachedStatus(value) {
    value = String(!!value);
    const cacheKey = this.getCacheKey();
    localStorage.setItem(cacheKey, value);
  },
};

const getMultiCastStatus = () => {
  const userId = window.pageProps.operationUserId;
  const key = `_cache_switch_status_hide_multicast_${userId}`;
  const cache = localStorage.getItem(key);
  return cache === 'true';
};

class LeadsManagePage extends React.Component {
  componentWillUnmount() {
    UNIQUE_STATUS = null;
  }

  componentDidMount() {
    this.checkIsInCarScoreWhiteList();
    // 优先级最高的工作：获取线索去重按钮的状态
    // RPCFactory.leadsManage.getUniqueStatus()
    //   .done((data) => {
    //     UNIQUE_STATUS = data;
    //   })
    //   .always(() => {
    //     this.setState({ hideRepeatRegisterLeads: !!UNIQUE_STATUS });
    //   });

    // 如果是TMC环境，则查询 TMC 配置
    if (judgeIsFromTMC()) {
      this.queryTMCConfig();
    }

    this.query = _.get(this, 'lvObj.current.loadList', () => {
      console.log('load listview ref failed');
    });

    // 查询是否支持"智能排序"
    RPCFactory.leadsOrder
      .canUseSmartOrder()
      .done((data) => {
        let { canUseSmartOrder } = data;
        canUseSmartOrder = canUseSmartOrder || false;
        this.setState({ canUseSmartOrder });
      })
      .fail((ret, msg) => {
        console.error(`Request for canUseSmartOrder error: ${msg}`);
      });

    // 获取所有企业下的所有员工
    RPCFactory.qwCustomer
      .getAllEmployes()
      .done((data) => {
        const allEmployees = (data.entities || [])
          .map(item => ({
            value: item.wxWorkUserId,
            label: item.wxWorkUserId,
          }));
        this.setState({ allEmployees });
      })
      .fail((ret, msg) => {
        console.error(`Request for get all employees error: ${msg}`);
      });

    const industryCars = [
      21474840595,
      21474840597,
      21474840596,
      21474840598,
      21474840601,
      21474840594,
      21474840599,
      21474840600,
      21474840592,
      21474840602,
      21474840590,
      21474840593,
      21474840591,
      21474840583,
    ];

    this.setState({
      showHideMultiSendBtn: industryCars.includes(window.pageProps.industryCode2),
    });

    // 获取默认展示列
    this.setColumnArr(); // 获取配置过的自定义列列表
    this.getCustomizedAttributes();
    this.getTagGroups();
    this.switchRole(this.props.tab);
    this.getReportUniqueStatus();

    // 获取上传、下载按钮
    this.setUploadBtnList();
    this.setDownloadBtnList();
  }
  getTagGroups = () => {
    RPCFactory.labelGroupManage.getGroups({ withChildren: true })
      .done((data) => {
        this.transformTagGroups(data.entities);
      })
      .fail((ret, msg) => { });
  };
  /**
   * @description 获取自定义属性
   */
  getCustomizedAttributes = () => {
    RPCFactory.accountSettings
      .getCustomizedAttributes()
      .done((data) => {
        const { customizedAttributes = [] } = data;
        this.setState({
          customizedAttributes,
        });
      })
      .fail((ret, msg) => { });
  };
  setColumnArr = (columnValueName) => {
    RPCFactory.accountSettings
      .getCustomRules()
      .done((data) => {
        const arr = [
          {
            name: 'user',
            title: '',
            list: [],
          },
        ];
        data.forEach((item) => {
          const { settingName, fieldNames = [], customizedAttributeNames = [] } = item;
          arr[0].list.push({
            label: settingName,
            value: settingName,
            keys: [...fieldNames, ...customizedAttributeNames],
          });
        });
        const localColumnConfig = this.getLocalColumnConfig(data);
        const columnValue = this.getLocalColumnConfigName();
        this.setState({ customerColumnsData: arr, selected: localColumnConfig, columnValue: { user: columnValueName || columnValue } });
      })
      .fail((ret, msg) => { });
  };
  getOwnerIds() {
    RPCFactory.employeeManage
      .getEmployees(undefined, undefined, undefined, undefined, undefined, undefined)
      .done((data) => {
        const leadsOwner = [];
        (data.entities || []).forEach((employee) => {
          // var mark = employee.status == EmployeeFrozenStatus.NORMAL ? "有效" : "封停";
          let active = true;
          if (employee.status !== 0) active = false;
          if (employee.leadsReceiveStatus === 0) active = false;
          leadsOwner.push({
            active,
            value: employee.userId,
            label: `${employee.name} - ${employee.userGroupName}`,
          });
        });
        this.setState({ leadsOwners: leadsOwner });
      });
  }

  // 需求: 873967511
  getReportUniqueStatus() {
    if (this.state.isFreeLogin) return;
  }

  handleUpdateLeadsTags = (leadsIds) => (tags) => {
    if (!this.lvObj.current) return;
    if (!Array.isArray(leadsIds)) throw new Error('leadsIds needs to be an array.');
    const idSet = new Set(leadsIds);
    const data = JSON.parse(JSON.stringify(this.lvObj.current.tableData));
    for (const lead of data.list) {
      if (!idSet.has(lead.leadsId)) continue;
      const _tags = lead.tags.filter((tag) => !tag.customizedTagGroup);
      lead.tags = _tags.concat(tags);
      idSet.delete(lead.leadsId);
    }
    this.lvObj.current.setTableData(data);
  };

  handleEditLeadsTags(leads) {
    const refreshListData = this.handleUpdateLeadsTags([leads.leadsId]);
    showTagEditor({
      leadsId: leads.leadsId,
      selected: leads.tags,
      submitFn: refreshListData,
    });
  };

  onBatchUpdateLabel() {
    const refreshListData = (tags) => {
      // 批量操作完成之后需要关闭批量操作条
      this.lvObj.current.setSelectKeys([]);
      this.lvObj.current.setBatchShow(false);
      this.handleUpdateLeadsTags(this.state.tableColumnChecks)(tags);
    };
    showTagEditor({
      isBatch: true,
      leadsIds: this.state.tableColumnChecks,
      // 批量修改的时候显示不选中任何标签
      selected: [],
      submitFn: refreshListData,
    });
  };

  initQuery = {
    startActionDate: {
      start_time: moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  };

  state = {};

  constructor(props) {
    super(props);
    // 用来挂载在 listview 之上获取数据
    this.lvObj = createRef();
    this.nowDateStr = DateUtil.getTodayDateStr();
    this.weekAgoDateStr = DateUtil.getWeekAgoDateStr();
    this.batchMarkUploadedFile = '';
    // 权限
    this.isShowComponeyLeads =
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_OBSERVER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_AGENCY' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_ASSISTANT' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_DATA_ANALYST' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_ADOPERATOR';
    this.isShowGroupLeads = window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER';
    this.isShowSelfLeads =
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_OBSERVER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER';

    const getDefaultScope = () => {
      const scopeMap = {
        company: 3,
        group: 2,
        self: 1,
      };
      return scopeMap[this.props.tab] || 0;
    };
    const scope = getDefaultScope();
    this.state = {
      /**
       *  搜索区
       */
      pageSize: 10,
      pageIndex: 1,
      showUpdateOperationDialog: false,
      showCallConfirmDialog: false,
      startActionDate: this.weekAgoDateStr,
      endActionDate: this.nowDateStr,
      ownerIds: [],
      searchOwnerValue: '',
      leadsOwners: [],
      orderType: LeadsOrderType.DEFAULT.getId(),
      // 落地页id搜索select
      pageSelect: {},
      // 联系人信息搜索group
      searchGroup: {},
      // 是否在线索管理页
      isInFormalLeadsPage: !this.props.isTest,

      // 表格
      tableColumnChecks: [],
      data: [],

      // 表格自定义头
      barchBarDisplayValue: 'none',

      // 详情portal
      leadsDetailPortalTarget: '',
      detailLeadsId: '',

      // 表格编辑
      followTagDialog: { show: false },
      leadsScoreDialog: { show: false, disable: false },
      isShowMultiMark: false,
      isShowLeadsImport: false,
      isShowSOPLeadsImport: false,
      batchMarkLoadingShow: false,
      curRoleType: this.props.tab,
      showScanWechatNotice: false,
      leadsQueryScope: scope,
      // 自定义列
      columnShow: false,
      fixed: [],
      selected: leadsCommonFuncAndConfig.defaultSelectedColumns,
      modalSelected: [],
      columnChecked: true,
      columnDisabled: false,
      columnInputValue: '',
      columnValue: '',
      customerColumnsData: [],
      settingOldName: '',
      columnStatus: '',

      // 自定义属性
      customizedAttributes: [],
      tagGroups: [],

      // 上传按钮列表
      uploadBtnList: [],
      uploadBtnValue: '',

      // 下载按钮列表
      downloadBtnList: [],
      downloadBtnValue: '',

      helpBlock: '',
      hideRepeatRegisterLeads: PageUtil.getLeadsDedupFromStorage(),
      canUseSmartOrder: false,
      actionSubTypes: [],
      scoreTag: leadsScoreTips.intentionScoreTag,
      lgMethodTags: [],

      isFreeLogin: isLeadsRole('免登录'),
      reportUnique: ReportUniqueTool.getCachedStatus(),

      // 所有企业下的所有员工
      allEmployees: [],

      showBatchDistribute: false,
      showHideMultiSendBtn: false,
      hideMultiSend: getMultiCastStatus(),
      pageKey: `${this.props.location.pathname}-${window.pageProps.operationUserId}`,

      // TMC 配置
      tmcConfig: null,
      // 线索回收
      showRecycleDialog: false,
      recycling: false,
    };

    this.TipComponent = leadsCommonFuncAndConfig.getTipComponent(this);
    this.filterControls = [];

    this.canDistribute = isLeadsRole('管理员', '超级管理员', '广告优化师', '数据分析人员', '客服经理');

    /**
     * @function 请求方法
     * @return Promise.resolve()
     */
    // 业务负载--变量
    this.payloads = () => ({});
    // 业务负载--方法
    this.customFunctions = () => ({});
    this.getFiltersData();

    const query = new URLSearchParams(this.props.location.search);
    const insertDefaultQueryValue = key => {
      if (!query.has(key)) return;
      this.initQuery[key] = query.get(key);
    };
    ['componentId', 'pageId'].forEach(insertDefaultQueryValue);

    // 处理 MP 跳转过来携带的查询参数
    (() => {
      /**
       * 保证时间筛选区间以开始时间为准不超过一年
       */
      const validateEndTime = () => {
        const initStartDay = this.initQuery.startActionDate.start_time;
        const initEndDay = this.initQuery.startActionDate.end_time;
        const finalEndDay = moment(initStartDay).add(365, 'day');
        if (finalEndDay.valueOf() < moment(initEndDay).valueOf()) {
          this.initQuery.startActionDate.end_time = finalEndDay.format('YYYY-MM-DD');
        }
      };
      const urlQuery = new URLSearchParams(window.location.search);
      if (urlQuery.has('campaignId')) {
        this.initQuery.campaignId = urlQuery.get('campaignId');
      }
      if (urlQuery.has('startTime')) {
        const startTime = urlQuery.get('startTime');
        if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(startTime)) {
          this.initQuery.startActionDate.start_time = startTime;
          validateEndTime();
        }
      }
    })();

    // 处理TMS跳转携带过来的查询参数
    (() => {
      const urlQuery = new URLSearchParams(window.location.search);
      if (urlQuery.has('pageId')) {
        this.initQuery.pageId = urlQuery.get('pageId');
      } else if (urlQuery.has('followTags')) {
        this.initQuery.followTags = urlQuery.get('followTags').split(',');
      }
    })();
  }

  setLocalColumnConfigName = (name) => {
    localStorage.setItem(this.state.pageKey, name);
  }

  getLocalColumnConfigName = () => {
    const settingName = localStorage.getItem(this.state.pageKey);
    return settingName
  }

  getLocalColumnConfig = (customRules) => {
    const settingName = this.getLocalColumnConfigName();
    const config = customRules.find(item => item.settingName === settingName) || {}
    return config.fieldNames || leadsCommonFuncAndConfig.defaultSelectedColumns;
  }

  onMultiSendChange = (e, checked) => {
    this.setState({ hideMultiSend: checked });
    const userId = window.pageProps.operationUserId;
    const key = `_cache_switch_status_hide_multicast_${userId}`;
    localStorage.setItem(key, String(checked));
  }

  onCheckedChange = (checked) => {
    this.setState({ hideRepeatRegisterLeads: checked });
    this.lvObj.current.setPageNo(1);
  };

  handleReportUniqueChange = (e, checked) => {
    ReportUniqueTool.setCachedStatus(checked);
    this.setState({ reportUnique: checked });
    this.lvObj.current.setPageNo(1);
  };

  showColumn = (data, value) => {
    this.setState({
      columnShow: true,
      columnChecked: true,
      settingOldName: data.label,
      columnInputValue: data.label,
      // selected: data.keys,
      modalSelected: data.keys,
    });
  };

  selfShowColumn = () => {
    this.setState({
      columnShow: true,
      columnChecked: true,
      settingOldName: '',
      // selected: leadsCommonFuncAndConfig.defaultSelectedColumns,
      modalSelected: leadsCommonFuncAndConfig.defaultSelectedColumns,
    });
  };

  deleteColumn = (data) => {
    RPCFactory.accountSettings
      .deleteCustomRules(data.label)
      .done((data) => {
        this.setColumnArr();
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  };

  columnCancel = () => {
    this.setState({
      columnShow: false,
    });
  };

  columnSubmit = (state) => {
    const { columnInputValue } = this.state;
    if (
      !!this.state.columnChecked &&
      this.state.settingOldName == '' &&
      this.state.customerColumnsData[0].list &&
      this.state.customerColumnsData[0].list.length > 9
    ) {
      alert('设置已达上限，如需继续添加请先删除');
      return;
    }
    if (this.state.columnChecked && this.state.columnInputValue.replace(/(^s*)|(s*$)/g, '').length == 0) {
      window.alert('自定义名称不能为空');
      return;
    }
    this.setState(state);

    const { selected } = state;
    const rules = selected;
    // const rules = _.filter(selected, (v) => _.find(this.state.customizedAttributes, (x) => x.name !== v));
    const customizedAttributeNames = _.filter(selected, (v) =>
      _.find(this.state.customizedAttributes, (x) => x.name === v),
    );
    if (this.state.columnChecked && this.state.settingOldName == '') {
      RPCFactory.accountSettings
        .setCustomRules(rules, this.state.columnInputValue, customizedAttributeNames)
        .done((data) => {
          this.setLocalColumnConfigName(columnInputValue);
          this.setColumnArr(columnInputValue);
        })
        .fail((ret, msg) => {
          alert(`请求失败，msg:${msg}`);
        });
    } else if (this.state.columnChecked && this.state.settingOldName != '') {
      RPCFactory.accountSettings
        .updateCustomRules(rules, this.state.columnInputValue, this.state.settingOldName, customizedAttributeNames)
        .done((data) => {
          this.setLocalColumnConfigName(columnInputValue);
          this.setColumnArr(columnInputValue);
        })
        .fail((ret, msg) => {
          alert(`请求失败，msg:${msg}`);
        });
    }
    this.setState({
      columnShow: false,
      columnChecked: false,
      columnInputValue: '',
    });
  };

  columnChange = (e, value, props) => {
    const len = this.state.columnInputValue.length || 0;
    if (len < 1) {
      this.setState({
        columnStatus: 'error',
        helpBlock: '请输入名称',
      });
    }
    this.setState({
      columnChecked: value,
      selected: props.currentState.selected,
    });
  };

  columnHandleChange = (event, value, itemValue) => {
    this.setState({
      columnValue: value,
      selected: itemValue.keys,
    });
    this.setLocalColumnConfigName(itemValue.label);
  };
  resetColums = () => {
    this.setState({
      columnValue: '',
      selected: leadsCommonFuncAndConfig.defaultSelectedColumns,
    });
    this.setLocalColumnConfigName('');
  }


  columnHandleInputChange = (event, value, props) => {
    const len = value.length || 0;
    let helpBlock = '';
    let status = '';

    if (len < 1) {
      status = 'error';
      helpBlock = '请输入名称';
    } else if (len > 30) {
      status = 'error';
      helpBlock = '名称不能超过30个字';
    } else {
      status = '';
      helpBlock = '';
    }
    this.setState({
      columnInputValue: value,
      columnStatus: status,
      helpBlock,
      modalSelected: props.currentState.selected,
    });
  };

  hideBarchBar = () => {
    this.setState({ barchBarDisplayValue: 'none' });
  };

  hideDistributeOwnerDialog = (event) => {
    this.setState({ showBatchDistribute: false });
  };

  leadsBatchDistribute = (data) => {
    const params = {
      distributeType: data.method === 'custom' ? 2 : 1,
      leadsIds: data.leads || [],
      distributeItems: data.employees.map((item) => {
        const obj = {
          targetOwnerId: item.id,
          leadsCount: data.map[item.id] || 0,
        };
        if (data.method === 'custom') {
          obj.proportion = item.percent;
        }
        return obj;
      }),
    };
    return new Promise((res) => {
      RPCFactory.leadsManage.leadsBatchDistribute(params)
        .done(() => {
          setTimeout(() => {
            this.query();
            this.hideBarchBar();
            this.hideDistributeOwnerDialog();
            this.lvObj.current.loadList();
            this.lvObj.current.setSelectKeys([]);
            this.lvObj.current.setBatchShow(false);
            res();
          }, 300);
        })
        .fail((ret, msg) => {
          alert(msg);
          res();
        });
    });
  };

  getList = (params) => new Promise((res, rej) => {
    this.setState({ showLoading: true });
    RPCFactory.leadsManage
      .getLeadsModelViewInfo(window.pageProps.uid, params, window.pageProps.appId, window.pageProps.adUserType)
      .done((data) => {
        this.setState({
          data: data.entities,
          totalSize: data.size,
        });
        this.setState({ showLoading: false });
        const leadsData = {
          list: [],
          page_info: {
            total_number: 0,
          },
        };
        leadsData.list = data.entities;
        leadsData.page_info.total_number = data.size;
        res(leadsData);
      })
      .fail((ret, msg) => {
        this.setState({ showLoading: false });
        rej(msg);
        window.alert(msg);
      });
  });

  /**
   * 查询
   * @param params
   */
  query = () => {
    console.log('listview not inited');
  };

  /**
   * =====================================================================
   * 上传/下载相关操作 start
   */
  setUploadBtnList = () => {
    let list = [];
    if (this.state.isInFormalLeadsPage) {
      if (this.props.tab === 'company') {
        if (window.pageProps.privileges.includes(PrivilegeCode.DEFEAT_LEADS_IMPORT.getCode())) {
          list.push({
            label: '上传战败线索',
            value: 'SOPLeadsImport',
          });
        }

        list.push({
          label: '导入线索',
          value: 'leadsImport',
        });
      }

      list = [...list,
      {
        label: '上传标记',
        value: 'multiMark',
      },
      ];

      this.setState({
        uploadBtnList: list,
      });
    }
  }

  uploadHandleChange = (event, value) => {
    const currentValue = value.upload;
    if (currentValue === 'leadsImport') {
      this.showLeadsImport();
    } else if (currentValue === 'multiMark') {
      this.showMultiMark();
    } else if (currentValue === 'SOPLeadsImport') {
      this.showSOPLeadsImport();
    }

    this.setState({
      uploadBtnValue: value
    });
  }

  setDownloadBtnList = () => {
    const list = [{
      label: '下载线索数据',
      value: 'downloadLeads',
    }];

    if (window.pageProps.privileges.includes(
      PrivilegeCode.LEADS_CALL_RECORD_DOWNLOAD.getCode(),
    )) {
      list.push({
        label: '下载通话数据',
        value: 'downloadCallRecords',
      })
    }

    this.setState({
      downloadBtnList: list,
    });
  }

  downloadHandleChange = (event, value) => {
    const currentValue = value.download;
    RPCFactory.checkLogin
      .advertiserPageLogin()
      .done((result) => {
        if (result && result.success) {
          if (currentValue === 'downloadLeads') {
            this.downloadLeads();
          } else if (currentValue === 'downloadCallRecords') {
            this.downloadCallRecords();
          }
        } else if (judgeIsFromTMC()) {
          top.postMessage({ type: 'freshToken' }, '*');
        } else if (result) {
          window.location = result.ssoURL;
        }
      })
      .fail((ret, msg) => {
        alert(msg);
      });

    this.setState({
      downloadBtnValue: value
    });
  }

  /**
 * =====================================================================
 * 上传/下载相关操作 end
 */

  getDownloadQueryParams = () => {
    const queryData = { ..._.get(this, 'lvObj.current.requestParams') || {} };
    delete queryData.pageIndex;
    delete queryData.pageSize;
    const queryItems = Object.keys(queryData).map(property => {
      const value = queryData[property];
      if (value === undefined) return undefined;
      let key = property;
      if (Array.isArray(value)) {
        key += 'Str';
      }
      return { key, value };
    }).filter(Boolean);
    queryItems.unshift({ key: 'accountId', value: window.pageProps.uid });
    if (this.state.curRoleType == 'group') {
      queryItems.push({
        key: 'userGroupId',
        value: window.pageProps.userGroupId
      })
    }
    const queryStr = `?${queryItems.map(item => `${item.key}=${item.value}`).join('&')}`;
    return queryStr;
  };

  /**
   * 下载
   * @param event
   */
  downloadLeads = (isBatch) => {
    isBatch = isBatch === true;
    const selectedColumns = (this.showColumns || []).filter(Boolean).map((item) => item.name);
    const selectLeads = this.state.tableColumnChecks || [];
    const query = new URLSearchParams(this.getDownloadQueryParams());
    const addArrParams = ([key, arr]) => {
      if (!Array.isArray(arr) || arr.length < 1) return;
      query.set(key, arr.join(','));
    };
    [
      ['customizedColumns', selectedColumns],
      isBatch && ['leadsIds', selectLeads],
    ].filter(Boolean).forEach(addArrParams);
    const queryParam = `?${query.toString()}`;

    if (window.pageProps.adUserType == CustomerType.DIRECT.getId() && window.pageProps.appId) {
      window.location.href = Common.ASSOCIATE_DOWNLOAD + queryParam;
    } else {
      window.location.href = Common.LEADS_DOWNLOAD + queryParam;
    }
  };

  /**
   * 下载
   * @param event
   */
  downloadCallRecords = () => {
    const queryParam = this.getDownloadQueryParams();
    window.location.href = Common.LEADS_CALL_RECORD_DOWNLOAD + queryParam;
  };

  // 详情关闭时，回调
  onDetailShutdown = () => {
    Mask.hide();
    this.setState({ leadsDetailPortalTarget: '' });
    this.lvObj.current.loadList();
  };

  // 点击线索时，查看详情
  showDetail = (e, leadsId, name, location, advertiserId) => {
    Mask.show();
    this.setState({
      leadsDetailPortalTarget: document.getElementById('leadsDetail'),
      detailLeadsId: leadsId,
      detailLeadsName: name,
      detailLeadsLocation: location,
      detailAdvertiserId: advertiserId
    });
  };

  /**
   * =====================================================================
   * 表格区部分
   */
  renderLeadsId = (type, name, value, data) => {
    if (type != 'head') {
      // 6个字符截断
      let text = '';
      if (value && value.length >= 6) {
        text = `${value.substr(0, 6)}...`;
      } else {
        text = value;
      }

      const nameLabel = (
        <a style={{ cursor: 'pointer' }} onClick={(e) => this.showDetail(e, data.leadsId, data.name, data.telLocation, data.accountId)}>
          {text ? text : '未命名'}
        </a>
      );

      return (
        <div title={value}>
          {nameLabel}
          <div style={{ display: 'none' }}>{data.leadsId}</div>
        </div>
      );
    }
    return value;
  };

  renderTel = (type, name, value, data) => {
    if (!value) {
      return;
    }

    if (type === 'head') {
      return <div style={{ paddingLeft: 22 }}>{value}</div>;
    }
    let call;
    const canCall =
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_AGENCY' &&
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_ADOPERATOR' &&
      !isSubAccount();
    if (canCall) {
      call = (
        <a
          style={{ cursor: 'pointer' }}
          className="call-num"
          onClick={(event) => this.showCallDialog(event, value, data.leadsId, data.name, data.telLocation, data.tags)}
        >
          <i className="icon-phone" style={{ marginLeft: 4 }} />
          {value}
        </a>
      );
    } else {
      call = value;
    }
    return <div className="phone-number">{call}</div>;
  };

  followTagDialog = {
    show: (target, value, leadsId) => {
      const { followTagDialog } = this.state;
      followTagDialog.eventTarget = target;
      followTagDialog.eventTargetLeft = target.getBoundingClientRect().left;
      followTagDialog.eventTargetTop = target.getBoundingClientRect().top;
      followTagDialog.show = true;
      followTagDialog.leadsId = leadsId;
      followTagDialog.leadsFollowTag = value;
      this.setState({ followTagDialog });
    },
    onClose: () => {
      const { followTagDialog } = this.state;
      followTagDialog.show = false;
      this.setState({ followTagDialog });
    },
    onChange: (event, value, s) => {
      const { followTagDialog } = this.state;
      followTagDialog.leadsFollowTag = value;
      this.setState({ followTagDialog });
    },
    onConfirm: () => {
      const { followTagDialog, tableColumnChecks } = this.state;
      RPCFactory.leadsManage
        .updateLeadsFollowTags(tableColumnChecks, parseInt(followTagDialog.leadsFollowTag, 10))
        .done(() => {
          followTagDialog.disable = false;
          this.setState({ followTagDialog });
          this.followTagDialog.onClose();
          this.lvObj.current.loadList();
          this.lvObj.current.setSelectKeys([]);
          this.lvObj.current.setBatchShow(false);
        })
        .fail((status, msg) => {
          alert(`请求失败，msg:${msg}`);
          followTagDialog.disable = false;
          this.setState({ followTagDialog });
        });
    },
  };


  leadsScoreDialog = {
    show: (target, value, leadsId) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.eventTarget = target;
      leadsScoreDialog.eventTargetLeft = target.getBoundingClientRect().left;
      leadsScoreDialog.eventTargetTop = target.getBoundingClientRect().top;
      leadsScoreDialog.show = true;
      leadsScoreDialog.leadsId = leadsId;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onClose: () => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.show = false;
      this.setState({ leadsScoreDialog });
    },
    onChange: (event, value) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onConfirm: () => {
      const { leadsScoreDialog, tableColumnChecks } = this.state;
      RPCFactory.leadsManage
        .updateLeadsIntentionTags(window.pageProps.uid, tableColumnChecks, leadsScoreDialog.leadsIntentionScoreTag)
        .done(() => {
          leadsScoreDialog.disable = false;
          this.setState({ leadsScoreDialog });
          this.leadsScoreDialog.onClose();
          this.lvObj.current.loadList();
          this.lvObj.current.setSelectKeys([]);
          this.lvObj.current.setBatchShow(false);
          // store.dispatch({
          // 	type: LeadsManageAction.UPDATE_SINGLE_LEADS,
          // 	updateType: LeadsEditableFieldType.INTENTION,
          // 	targetValue: leadsScoreDialog.leadsIntentionScoreTag,
          // 	targetLeadsId: leadsScoreDialog.leadsId
          // });
        })
        .fail((status, msg) => {
          alert(`请求失败，msg:${msg}`);
          leadsScoreDialog.disable = false;
          this.setState({ leadsScoreDialog });
        });
    },
  };
  checkIsInCarScoreWhiteList = () => {
    RPCFactory.account.check_whitelist(window.pageProps.uid, 'auto.intention.score.whiteList').done((data) => {
      if (data) {
        this.setState({ scoreTag: leadsScoreTips.carScoreTag });
      }
    });
  };

  queryTMCConfig = () => {
    RPCFactory.leadsManage
      .getTmcConfig()
      .done((data) => {
        this.setState({ tmcConfig: data });
      })
      .fail((ret, msg) => {
        window.alert(`查询TMC配置失败, ${msg}`);
      });
  };

  renderIntentionScoreTagName = (type, name, value, data) => {
    const popoverstyle = {
      maxWidth: '800px',
    };

    const { scoreTag } = this.state;
    const popover = (
      <PopOver style={popoverstyle}>
        <div className="poptable">
          <Table hideThead={true} data={scoreTag}>
            <Column name="enumValue" minWidth={200}>
              枚举值
            </Column>
            <Column name="enumDetail">说明</Column>
          </Table>
        </div>
      </PopOver>
    );
    if (type == 'head') {
      return (
        <div>
          {value}
          <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
            <i className="icon icon-help">
              <i></i>
            </i>
          </OverlayTrigger>
        </div>
      );
    }
    return <span>{value}</span>;
  };

  /**
  * 表格区部分 end
  * =====================================================================
  */

  /**
   * =====================================================================
   * 外呼部分
   */
  showCallDialog = (event, callee, leadsId, name, telLocation, tags) => {
    if (!callee) {
      alert('被叫号码不能为空');
      return;
    }

    if (judgeIsFromTMC()) {
      top.postMessage({
        type: 'showCallDialog', data: {
          showCallConfirmDialog: true,
          callee,
          calleeName: name,
          calleeArea: telLocation,
          calleeLeadsId: leadsId,
          tags,
        }
      }, '*')
    } else {
      this.setState({
        showCallConfirmDialog: true,
        callee,
        calleeName: name,
        calleeArea: telLocation,
        calleeLeadsId: leadsId,
        tags,
      });
    }
  };

  onCancelCall = (event) => {
    this.setState({ showCallConfirmDialog: false });
  };

  onSubmitCall = (event) => {
    RPCFactory.call
      .call(window.pageProps.uid, this.state.callee, this.state.calleeLeadsId)
      .done((data) => {
        this.onCancelCall({});
      })
      .fail((ret, msg) => {
        alert(msg);
      });
  };

  showMultiMark() {
    this.setState({
      isShowMultiMark: true,
    });
  }

  hideMultiMark = () => {
    this.setState({
      isShowMultiMark: false,
    });
  };

  showLeadsImport() {
    this.setState({
      isShowLeadsImport: true,
    });
  }

  hideLeadsImport = () => {
    this.setState({
      isShowLeadsImport: false,
    });
  };

  showSOPLeadsImport = () => {
    this.setState({ isShowSOPLeadsImport: true });
  };
  hideSOPLeadsImport = () => {
    this.setState({ isShowSOPLeadsImport: false });
  };

  transformTagGroups = (tagGroupEntities) => {
    const tagGroups = _.filter(tagGroupEntities, 'tagCount');
    const tags = tagGroups.map((tagGroupItem) => {
      return {
        value: tagGroupItem.tagGroupId,
        desc: tagGroupItem.tagGroupName,
        options: tagGroupItem.tagList.map((tagItem) => {
          return {
            value: tagItem.tagId,
            desc: tagItem.tagName,
          };
        }),
      };
    });
    this.setState({ tagGroups: tags });
  };

  goToTestList() {
    this.props.history.push('/leads/leadsManage/companytestdatas');
  }

  switchRole(type) {
    const getList = () => {
      this.lvObj.current.setSelectKeys([]);
      this.lvObj.current.setBatchShow(false);
    };
    this.lvObj.current.setFilterData(this.initQuery);
    if (type == 'self') {
      this.getOwnerIds();
      this.setState(
        {
          curRoleType: type,
          ownerIds: [window.pageProps.operationUserId],
          leadsOwners: [],
          leadsQueryScope: 1,
        },
        getList,
      );
    } else if (type == 'group') {
      this.getOwnerIds();
      this.setState({ ownerIds: [], curRoleType: type, leadsQueryScope: 2 }, getList);
    } else if (type == 'company') {
      this.getOwnerIds();
      this.setState({ ownerIds: [], curRoleType: type, leadsQueryScope: 3 }, getList);
    }

    return false;
  }

  /**
   * 外呼部分end
   * =====================================================================
   */
  onCloseWechatNotice() {
    this.setState({ showScanWechatNotice: false });
  }

  getFiltersData = () => {
    const lgMethodTags = [];
    Object.keys(Tags.lgMethodTags).forEach((key) => {
      lgMethodTags.push({ value: key, label: Tags.lgMethodTags[key] });
    });
  }

  getAllFilterConfig = () => {
    this.filterControls = leadsCommonFuncAndConfig.getFilterControl();
    this.filterControls.splice(0, 0, {
      name: 'followTags',
      title: '线索状态',
      type: 'select',
      config: {
        multiple: true,
        search: false,
        data: _.get(this.props, 'industryState.stateQueryOptions', []),
        SelectionDataComponent: StateSelectionComponent,
      },
    });
    this.filterControls.splice(1, 0, {
      name: 'ownerIds',
      title: '归属人',
      type: 'select',
      config: {
        multiple: true,
        data: this.state.leadsOwners,
      },
    });
    this.filterControls.splice(2, 0, {
      name: 'leadsTags',
      title: '线索标签',
      type: 'select-tree',
      config: {
        multiple: true,
        data: this.state.tagGroups,
        showParentNodeLabel: false,
        valueType: 'child',
      },
    });
    this.filterControls.push({
      name: 'matchedWxWorkUserId',
      title: '企微客户归属人',
      type: 'select',
      config: {
        data: this.state.allEmployees,
        SelectionItemComponent,
        ValueAreaComponent,
      },
    });
    if (!window.pageProps.appId) {
      this.filterControls.splice(10, 0, {
        name: 'componentId',
        title: '组件ID',
        type: 'search',
        rules: [{ pattern: /^\d*$/, message: '请输入组件ID' }],
      });
    }
    if (window.pageProps.isInnerAccount) {
      this.filterControls.push({
        name: 'sourceAccountIdsStr',
        title: '来源广告主账号',
        type: 'search',
        rules: [{ pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '请输入来源广告主账号' }],
      });
    }
    let defaultFilterKeys = [
      'startActionDate',
      'followTags',
      'ownerIds',
      // 'leadsTags',
      'actionSubTypes',
      'leadsSources',
      'leadsTouchTags',
      'intentionTags',
      // 'leadsCallCleaningTags' // 默认展示智能标签筛选项，同步自定义列 by fighitingliu
    ];
    if (this.state.isInFormalLeadsPage) {
      defaultFilterKeys.splice(3, 0, 'leadsTags');
    }
    if (this.state.curRoleType === 'self') {
      this.filterControls = this.filterControls.filter(
        item => item.name !== 'ownerIds'
      );
      defaultFilterKeys = defaultFilterKeys.filter(
        item => item.name !== 'ownerIds'
      );
    }
    if (this.state.canUseSmartOrder) {
      this.filterControls.push({
        name: 'orderType',
        title: '排序方式',
        type: 'select',
        config: {
          data: Object.keys(LeadsOrderType).map(key => ({
            value: LeadsOrderType[key].getId(),
            label: LeadsOrderType[key].getDesc(),
          })),
        },
      });
      defaultFilterKeys.push('orderType');
    }
    if (window.pageProps.isInnerAccount) {
      this.filterControls.push({
        name: 'lgMethods',
        title: '请选择LG处理方式',
        type: 'select',
        config: {
          multiple: true,
          data: Object.keys(Tags.lgMethodTags).map((key) => ({
            label: Tags.lgMethodTags[key],
            value: key,
          })),
        },
      });
      defaultFilterKeys.push('lgMethods');
    }
    if (isXunda()) {
      let title = '楼盘名称';
      if (isXunda('车')) title = '商家名称';
      this.filterControls.push({
        title,
        type: 'select',
        name: 'leadsPoolId',
        config: {
          multiple: false,
          theNumberOfDisplay: 100,
          data: this.props.xundaData.pools.map((item) => ({
            value: item.leads_pool_id,
            label: item.name,
          })),
        },
      });
    }
    const query = new URLSearchParams(this.props.location.search);
    const insertDefaultFilterKeys = (key) => {
      if (!query.has(key)) return;
      defaultFilterKeys.push(key);
    };
    ['componentId', 'pageId'].forEach(insertDefaultFilterKeys);
    this.customFilterConfigure = useCustomColumn({
      defaultFilterKeys,
      controls: this.filterControls,
      storageKey: 'ams:user_profile:advertiser_custom_filters_/adhome/advertiser/account',
    });
  }

  getShowColumns = () => {
    const columnWidthStr = localStorage.getItem(`ColumnWidth${window.pageProps.uid}`);
    let columnWidth = undefined;
    if (columnWidthStr) {
      columnWidth = JSON.parse(columnWidthStr);
    }
    this.columnMap = leadsCommonFuncAndConfig.getColumnsMap(this.state.customizedAttributes, this);
    this.columnMap.name = {
      name: 'name', customRender: this.renderLeadsId, title: '姓名', fixedable: true, adjustWidth: true,
      style: columnWidth && columnWidth.name ? { width: `${columnWidth.name}px` } : {}
    },
    this.columnMap.tel = {
      name: 'tel', customRender: this.renderTel, title: '电话', fixedable: true, adjustWidth: true,
      style: columnWidth && columnWidth.tel ? { width: `${columnWidth.tel}px` } : {}
    },
    this.columnMap.intentionScoreTagName = {
      name: 'intentionScoreTagName', customRender: this.renderIntentionScoreTagName, title: '线索评分', adjustWidth: true,
      style: columnWidth && columnWidth.intentionScoreTagName ? { width: `${columnWidth.intentionScoreTagName}px` } : {}
    },
    this.columnMap.leadsOpt = {
      name: 'leadsOpt', customRender: (type, name, value, data) => {
        return leadsCommonFuncAndConfig.renderLeadsOpt(
          type,
          name,
          value,
          data,
          this.state.tmcConfig,
          (e) => this.showDetail(e, data.leadsId, data.name, data.telLocation, data.accountId),
          (e) => this.showCallDialog(e, data.tel, data.leadsId, data.name, data.telLocation, data.tags)
        )
      }, title: '操作', fixedable: true, fixedAlign: 'right', adjustWidth: true, style: { width: '200px' }
    },
    this.showColumns = [];
    unmovableCells.forEach(value => {
      this.showColumns.push(this.columnMap[value]);
    })
    this.state.selected.forEach(value => {
      if (this.columnMap[value]) {
        this.showColumns.push(this.columnMap[value]);
      }
    })
    this.showColumns = this.showColumns.filter((item) => item?.name !== 'leadsOpt');
    this.showColumns.push(this.columnMap.leadsOpt);
  }

  onBatchDistribute = (e) => {
    if (this.canDistribute) {
      this.setState({ showBatchDistribute: true });
    } else {
      window.alert('您无权限进行分配！');
    }
  }

  onBatchChangeScore = (e) => {
    if (
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_OBSERVER' &&
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
    ) {
      this.leadsScoreDialog.show(e.target);
    } else {
      window.alert('您无权限进行评分！');
    }
  }

  onBatchChangeState = (e) => {
    if (
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_OBSERVER' &&
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
    ) {
      this.followTagDialog.show(e.target);
    } else {
      window.alert('您无权限进行状态修改！');
    }
  }

  onBatchDownload = () => {
    this.downloadLeads(true);
  }

  handleRowSelect = (_event, value, data, dataMap, clickArea) => {
    this.setState({ tableColumnChecks: value });
  }

  handleRecycle = () => {
    this.setState({ showRecycleDialog: true });
    beaconInstance.onUserAction(
      'btn_click',
      { page: '线索管理', name: '线索回收' },
    );
  };

  cancelRecycle = () => {
    this.setState({
      showRecycleDialog: false,
      recycling: false,
    });
  };

  recycleLeads = () => {
    const successCallback = () => {
      this.cancelRecycle();
      this.lvObj.current.loadList();
      this.lvObj.current.setSelectKeys([]);
      this.lvObj.current.setBatchShow(false);
    };

    this.setState({ recycling: true });
    const leadsIds = this.state.tableColumnChecks || [];
    RPCFactory.leadsManage.reclaim({ leadsIds })
      .done(() => setTimeout(successCallback, 1000))
      .fail((ret, msg) => {
        this.cancelRecycle();
        setTimeout(() => alert(msg));
      });
  };

  options = () => {
    this.getShowColumns();
    this.getAllFilterConfig();

    const canDownload = window.pageProps.privileges.includes(PrivilegeCode.LEADS_PUBLIC_POOL_EXPORT.getCode())
      || window.pageProps.privileges.includes(PrivilegeCode.LEADS_COMPANY_EXPORT.getCode())
      || window.pageProps.privileges.includes(PrivilegeCode.LEADS_GROUP_EXPORT.getCode())
      || window.pageProps.privileges.includes(PrivilegeCode.LEADS_SELF_EXPORT.getCode());

    const canGoToTestList = !this.props.isTest && this.props.tab === 'company' && isLeadsRole();

    return {
      fetchConfig: {
        action: this.getList,
        $onRequest: (params) => {
          // 在这处理请求参数对象
          const obj = { ...params };
          delete obj.startActionDate;
          delete obj.page_size;
          delete obj.page;
          obj.pageIndex = params.page;
          obj.pageSize = params.page_size;
          if (params.startActionDate) {
            obj.startActionDate = params.startActionDate.start_time;
            obj.endActionDate = params.startActionDate.end_time;
          }
          obj.leadsQueryScope = this.state.leadsQueryScope;
          if (!this.state.isInFormalLeadsPage) {
            obj.leadsTags = ['7'];
          }
          obj.hideRepeatRegisterLeads = this.state.hideRepeatRegisterLeads;
          if (this.state.isFreeLogin) {
            obj.hideOuterActionIdDuplicatedLeads = this.state.reportUnique;
          }
          if (this.state.showHideMultiSendBtn) {
            obj.hideBroadCastLeads = this.state.hideMultiSend ? 1 : 0;
          }
          return obj;
        },
        $onResponse(data) {
          try {
            data.list.forEach(obj => {
              obj.customizedAttributes.forEach(item => {
                obj[item.name] = item.value;
              });
            });
          } catch (error) {
            console.error(error);
          }
          return data;
        },
        $onError: window.alert,
      },
      toolbarConfig: {
        left: (
          <div className="toolbar-left">
            <h4>数据信息</h4>
          </div>
        ),
        right: (
          <div className="toolbar-right-group">
            {canGoToTestList && !judgeIsFromTMC() && (
              <Button onClick={this.goToTestList.bind(this)} className="borderless">
                <span className="spaui-text">查看测试线索 </span>
              </Button>
            )}

            {this.state.uploadBtnList.length > 0 && (
              <DropMenuTrigger
                dropMenu={
                  <DropMenu
                    data={[{
                      name: 'upload',
                      title: '',
                      list: this.state.uploadBtnList
                    }]}
                    value={this.state.uploadBtnValue}
                    onChange={this.uploadHandleChange}
                  />
                }
              >
                <Button className="borderless">
                  <i className="icon icon-upload"></i>上传数据
                </Button>
              </DropMenuTrigger>
            )}

            {canDownload && this.state.downloadBtnList.length > 0 && (
              <DropMenuTrigger
                dropMenu={
                  <DropMenu
                    data={[{
                      name: 'download',
                      title: '',
                      list: this.state.downloadBtnList
                    }]}
                    value={this.state.downloadBtnValue}
                    onChange={this.downloadHandleChange}
                  />
                }
              >
                <Button className="borderless btn-download">
                  <i className="icon icon-download" />
                  <span>下载数据</span>
                  <OverlayTrigger trigger="hover" overlay={(
                    <PopOver>
                      点击下载按钮分别支持下载当前自定义列线索数据和通话数据。
                    </PopOver>
                  )}>
                    <i className="icon icon-help" />
                  </OverlayTrigger>
                </Button>
              </DropMenuTrigger>
            )}

            <DropMenuTrigger
              dropMenu={
                <DropMenu
                  LinkComponent={leadsCommonFuncAndConfig.LinkComponent}
                  LinkComponentProps={{
                    edit: (data, value) => {
                      this.showColumn(data, value);
                    },
                    delete: (data) => {
                      this.deleteColumn(data);
                    },
                  }}
                  data={this.state.customerColumnsData}
                  value={this.state.columnValue}
                  onChange={this.columnHandleChange}
                  className="with-checkmark with-item-action"
                  preContent={
                    <Fragment>
                      <div className="spaui-submenu-header">
                        <Button onClick={this.resetColums} className="borderless full-width">
                          <span className="spaui-text">默认列表</span>
                        </Button>
                      </div>
                      <h5 className="spaui-submenu-head">常用自定义列</h5>
                    </Fragment>
                  }
                  postContent={
                    <div className="spaui-submenu-footer">
                      <Button onClick={this.selfShowColumn} className="borderless full-width">
                        <span className="spaui-text">自定义</span>
                      </Button>
                    </div>
                  }
                />
              }
            >
              <Button className="borderless">
                <i className="icon icon-columns"></i>自定义列
              </Button>
            </DropMenuTrigger>

            {
              this.state.showHideMultiSendBtn && (
                <div className="repeat-tips">
                  <span>隐藏多发线索</span>
                  <Switch
                    style={{ verticalAlign: '-3px', marginRight: '4px', lineHeight: 1 }}
                    checked={this.state.hideMultiSend}
                    onChange={this.onMultiSendChange}
                  ></Switch>
                </div>
              )
            }
            {
              this.state.isFreeLogin && (
                <div className="repeat-tips">
                  <span>上报数据去重展示</span>
                  <Switch
                    style={{ verticalAlign: '-3px', marginRight: '4px', lineHeight: 1 }}
                    checked={this.state.reportUnique}
                    onChange={this.handleReportUniqueChange}
                  ></Switch>
                </div>
              )
            }
            <LeadsDedupPart
              tip='开启按钮后，线索列表将不再展示带有“电话重复”标签的线索'
              onChange={this.onCheckedChange}
            />
          </div>
        )
      },
      filterConfig: {
        resetable: false,
        controls: this.filterControls,
        customConfigure: this.customFilterConfigure,
        defaultValuesByKey: this.initQuery,
      },
      batchConfig: {
        left: this.state.isInFormalLeadsPage && (
          <div className="toolbar-right-group">
            {
              this.props.tab !== 'self' && (
                <Button onClick={this.onBatchDistribute} className="borderless">
                  <i className="icon icon-batch"></i>线索分配
                </Button>
              )
            }
            {
              !judgeIsFromTMC() && isLeadsRole('管理员', '超级管理员') && (
                <Button onClick={this.handleRecycle} className="borderless">
                  <i className="icon icon-batch"></i>线索回收
                </Button>
              )
            }
            <Button onClick={this.onBatchChangeScore} className="borderless">
              <i className="icon icon-batch"></i>线索评分
            </Button>
            <Button onClick={this.onBatchChangeState} className="borderless">
              <i className="icon icon-batch"></i>线索状态
            </Button>
            {
              ENABLE_BATCH_TAG_UPDATE && (
                <Button onClick={this.onBatchUpdateLabel.bind(this)} className="borderless">
                  <i className="icon icon-batch"></i>线索标签
                </Button>
              )
            }
            <Button onClick={this.onBatchDownload} className="borderless">
              <i className="icon icon-download"></i>下载线索
            </Button>
          </div>
        ),
      },
      tableConfig: {
        defaultPageSize: 10,
        pageSizeOptions: [10, 20, 50, 200, 500],

        select: this.state.isInFormalLeadsPage ? 'multiple' : null,
        onColumnWidthChange: leadsCommonFuncAndConfig.handleColumnWidthChange,
        optionalConfig: {
          type: 'optional',
          target: 'leadsId',
          multiple: true,
          canOptional: true,
          onOptionalChange: this.handleRowSelect,
        },
        columns: this.showColumns,
      },
    };
  };

  render() {
    const cellsConfigMap = getCellsConfigMap(this.state.customizedAttributes);
    const cellsConfig = getCellsConfig(this.state.customizedAttributes);

    if (isXunda()) {
      let title = '楼盘';
      if (isXunda('车')) title = '商家'
      cellsConfigMap.leadsPoolId = {
        name: 'leadsPoolId',
        displayName: title,
        cellName: title,
        align: 'left',
        privilege: 'ALL',
      };
      cellsConfig.null.list[2].columns.push({
        name: 'leadsPoolId',
        displayName: title,
        cellName: title,
        align: 'left',
        privilege: 'ALL',
      });
    }

    return (
      <div className="main">
        {this.state.showScanWechatNotice && (
          <div className="notice">
            <span className="noticeText">
              扫码绑定微信通知已升级，当前接收微信消息通知需录入该员工的微信号，并扫码绑定公众号二维码。
            </span>
            <i className="icon icon-close" onClick={this.onCloseWechatNotice.bind(this)} />
          </div>
        )}
        <div className="page-pool">
          {
            !this.state.isInFormalLeadsPage && (
              <leadsCommonFuncAndConfig.TestHeader
                parentRouterText="全公司线索"
                parentRouterPath="#/leads/leadsManage/company"
              />
            )
          }
          {this.state.isInFormalLeadsPage && (<LeadsUploadDialog
            hideLeadsImport={this.hideMultiMark}
            query={this.query}
            updateLeadsImport={RPCFactory.leadsManage.updateLeadsBatchMark}
            isShowLeadsImport={this.state.isShowMultiMark}
            dialogTitle="上传标记线索状态"
            actionName="标记"
            downloadFailFileApi="/api/v1/leads/download_fail_batch_mark_convert_type"
            leadsUploadApi="/api/v1/leads/upload_batch_mark_file"
            uploadParaName="uploadedFile"
            importType="old"
            importDetail={
              <div className="exp">
                <p className="tt">不知道上传什么文件进行标记？</p>
                <p className="step">第一步：在线索管理下载线索数据，获取线索ID</p>
                <p className="step">
                  第二步：
                  <a target="_blank" href="/assets/doc/leads_status_change_template.xlsx">
                    下载文件模板
                  </a>
                  ，将线索ID信息移入文件并标记线索状态，然后在此处上传
                </p>
                <p className="exp-tip">
                  线索ID需与平台线索ID一致，未匹配数据或超出1000条的数据将作为无效数据处理。线索状态为：未分配、跟进中、已转换-潜在客户、已转换-高意向客户、已转换-已成单、无效-重复、无效-非本人、无效-未接通、无效-无意向、无效-定向外、无效-其他。
                </p>
              </div>
            }
          />)}
          {this.state.isInFormalLeadsPage && (
            <LeadsUploadDialog
              hideLeadsImport={this.hideSOPLeadsImport}
              query={this.query}
              updateLeadsImport={RPCFactory.leadsManage.updateLeadsImport}
              isShowLeadsImport={this.state.isShowSOPLeadsImport}
              dialogTitle="战败线索导入"
              actionName="导入"
              taskType={2}
            />
          )}
          {this.state.isInFormalLeadsPage && (
            <LeadsUploadDialog
              hideLeadsImport={this.hideLeadsImport}
              query={this.query}
              updateLeadsImport={RPCFactory.leadsManage.updateLeadsImport}
              isShowLeadsImport={this.state.isShowLeadsImport}
              dialogTitle="线索导入"
              actionName="导入"
              taskType={1}
              importWarning="腾讯线索管理平台仅支持广告主导入合法合规收集的线索，若导入非合法来源线索后使用平台外呼功能造成用户投诉，且广告主无法提供线索合法来源证明，本平台将限制该账号主体下所有账号对外部导入线索的外呼功能并追究相应责任。"
            />
          )}
          <div className="card" style={{ paddingTop: 0 }}>
            <div className="datalist">
              <ListView
                className="lv"
                ref={this.lvObj}
                options={this.options}
                payloads={this.payloads}
                customFunctions={this.customFunctions}
              />
            </div>

            <div id="leadsDetail"></div>
            {this.state.leadsDetailPortalTarget ? (
              <Portal target={this.state.leadsDetailPortalTarget}>
                <LeadsDetailComponent
                  showCallDialog={this.showCallDialog}
                  leadsId={this.state.detailLeadsId}
                  name={this.state.detailLeadsName}
                  location={this.state.detailLeadsLocation}
                  shutDown={this.onDetailShutdown}
                  isTestData={!this.state.isInFormalLeadsPage}
                  leadsTab={this.props.tab}
                  detailAdvertiserId={this.state.detailAdvertiserId}
                />
              </Portal>
            ) : (
              ''
            )}
            <CallConfirmDialog
              show={this.state.showCallConfirmDialog}
              callee={this.state.callee}
              leadsId={this.state.calleeLeadsId}
              tags={this.state.tags}
              updateTagsCallback={this.handleUpdateLeadsTags([this.state.calleeLeadsId])}
              name={this.state.calleeName}
              location={this.state.calleeArea}
              onCancel={this.onCancelCall}
              onSubmit={this.onSubmitCall}
            />
          </div>

          {this.state.isInFormalLeadsPage && (<Dialog
            eventTarget={this.state.followTagDialog.eventTarget}
            style={{ width: '400px' }}
            eventTargetLeftDeviation={-70}
            eventTargetTopDeviation={-110}
            show={this.state.followTagDialog.show}
            onClose={this.followTagDialog.onClose}
            onSubmit={(e) => {
              const { followTagDialog } = this.state;
              followTagDialog.disable = true;
              this.setState({ followTagDialog }, () => {
                this.followTagDialog.onConfirm();
              });
            }}
            onCancel={this.followTagDialog.onClose}
            title="修改线索状态"
            className="modal-w300 modal-simple"
            disabled={this.state.followTagDialog.disable}
          >
            <SelectTree
              placeholder="线索状态"
              // valueType="child"
              showParentNodeLabel={false}
              data={_.get(this.props, 'industryState.currentStateTree', [])}
              value={this.state.followTagDialog.leadsFollowTag}
              onChange={this.followTagDialog.onChange}
            />
          </Dialog>)}

          {this.state.isInFormalLeadsPage && (<Dialog
            eventTarget={this.state.leadsScoreDialog.eventTarget}
            style={{ width: '300px' }}
            eventTargetLeftDeviation={-70}
            eventTargetTopDeviation={-70}
            show={this.state.leadsScoreDialog.show}
            onClose={this.leadsScoreDialog.onClose}
            onSubmit={(e) => {
              const { leadsScoreDialog } = this.state;
              leadsScoreDialog.disable = true;
              this.setState({ leadsScoreDialog }, () => {
                this.leadsScoreDialog.onConfirm();
              });
            }}
            onCancel={this.leadsScoreDialog.onClose}
            title="修改线索评分"
            className="modal-w300 modal-simple"
            disabled={this.state.leadsScoreDialog.disable}
          >
            <Select
              placeholder="线索评分"
              data={leadsCommonFuncAndConfig.leadsIntentionTags}
              value={this.state.leadsScoreDialog.leadsIntentionScoreTag}
              onChange={this.leadsScoreDialog.onChange}
              onClear={this.leadsScoreDialog.onClear}
            />
          </Dialog>)}

          <Dialog
            type="normal"
            title="确定回收选中线索吗？"
            className="spaui-dialog-confirm-normal"
            show={this.state.showRecycleDialog}
            style={{ width: 400 }}
            onClose={this.cancelRecycle}
            onCancel={this.cancelRecycle}
            onSubmit={this.recycleLeads}
            footerStyle={{ textAlign: 'center' }}
            disabled={this.state.recycling}
          ></Dialog>

          <SpauiColumns
            show={this.state.columnShow}
            hideHeader={true}
            onCancel={this.columnCancel}
            onSubmit={this.columnSubmit}
            unmovableCells={unmovableCells}
            required={required}
            fixed={this.state.fixed}
            selected={this.state.modalSelected}
            cellsConfig={cellsConfig}
            cellsConfigMap={cellsConfigMap}
            columnInputValue={this.state.columnInputValue}
            columnHandleInputChange={this.columnHandleInputChange}
            dialogProps={{
              hideHeader: true,
            }}
            TipComponent={this.TipComponent}
          />
        </div>
        <BatchDistribute
          leads={this.state.tableColumnChecks || []}
          show={this.state.showBatchDistribute}
          onSubmit={this.leadsBatchDistribute}
          onClose={this.hideDistributeOwnerDialog}
          onCancel={this.hideDistributeOwnerDialog}
          tab={this.props.tab}
          ownerList={this.state.leadsOwners}
        />
      </div>
    );
  }
}

const ReduxLeadsManagePage = connect(mapStateToProps)(LeadsManagePage);
export default withXundaData(ReduxLeadsManagePage);
